import { render, staticRenderFns } from "./DialogEditStudentInGroup.vue?vue&type=template&id=23981d61&scoped=true"
import script from "./DialogEditStudentInGroup.vue?vue&type=script&lang=js"
export * from "./DialogEditStudentInGroup.vue?vue&type=script&lang=js"
import style0 from "./DialogEditStudentInGroup.vue?vue&type=style&index=0&id=23981d61&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23981d61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23981d61')) {
      api.createRecord('23981d61', component.options)
    } else {
      api.reload('23981d61', component.options)
    }
    module.hot.accept("./DialogEditStudentInGroup.vue?vue&type=template&id=23981d61&scoped=true", function () {
      api.rerender('23981d61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogEditStudentInGroup.vue"
export default component.exports